import { Environment, Network, RecordSource, Store, type FetchFunction } from 'relay-runtime';
import { fetchGraphQL, type RelayRecords } from './fetchGraphQL';

export const createEnvironment = (records?: RelayRecords) => {
  return new Environment({
    network: Network.create(fetchGraphQL as unknown as FetchFunction),
    store: new Store(new RecordSource((records ?? {}) as any))
  });
};
